import React from 'react';

import { mosaiqStyled } from '../../lib';

import { BadgeContainer } from './Badge.styles';

export type BadgeVariants = 'disabled' | 'warning' | 'success' | 'error' | 'info';

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: BadgeVariants;
}

const Badge = mosaiqStyled<BadgeProps, HTMLSpanElement>(
  ({ children, innerRef, variant, ...props }) => {
    return (
      <BadgeContainer ref={innerRef} variant={variant} {...props}>
        {children}
      </BadgeContainer>
    );
  },
);

Badge.displayName = 'Badge';

export default Badge;
